export const errorSupportMessage =
  'Please contact the AMA Unified Service Center at 800 262-3211, Monday – Friday, 7:00 AM – 6:00 PM CST, or send an email to MOSupport@ama-assn.org.';
